import { useTranslation } from 'react-i18next';

export default function TouristSection() {
  const { t } = useTranslation();
  const stats = t('tourist.stats', { returnObjects: true }) as Array<{ value: string; label: string }>;

  return (
    <section className="py-16 md:py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          {/* Text content */}
          <div className="flex-1 text-center lg:text-left">
            <p className="text-champagne-600 text-xs font-medium tracking-[0.2em] uppercase mb-3">
              Marmaris / Muğla
            </p>
            <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-dark-950 mb-4 leading-tight">
              {t('tourist.title')}
            </h2>
            <p className="text-dark-500 text-base md:text-lg leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {t('tourist.desc')}
            </p>

            {/* Stats */}
            <div className="flex items-center justify-center lg:justify-start gap-6 md:gap-10">
              {stats.map((stat, idx) => (
                <div key={idx} className="text-center">
                  <div className="text-champagne-600 font-display text-2xl md:text-3xl font-bold mb-1">
                    {stat.value}
                  </div>
                  <div className="text-dark-400 text-xs md:text-sm">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=marmaris%20turkey%20coastal%20view%20beautiful%20harbor%20with%20yachts%20palm%20trees%20blue%20sea%20warm%20sunny%20day%20luxury%20resort%20town%20turkish%20riviera%20premium%20atmosphere&width=800&height=600&seq=tourist&orientation=landscape"
                alt="Marmaris"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}